export const translations: any = {
  en: {
    text: 'Building the Future. A multinational construction and infrastructure conglomerate.',
    QuickLinks: 'Quick Links',
    Explore: 'Explore',
    Contactt: 'Contact',
    location: 'Tripoli & Benghazi, Libya',
    Subsidiaries: 'Subsidiaries',
    ABOUT: 'About Us',
    Services: 'Services',
    Contact: 'Contact Us',
    Equipment: 'Equipment',
    subfooter: [
      'Partner with us to build resilient',
      'infrastructure for the future',
    ],
    h1stsectionh2: 'We Are Building The Future',
    h1stsectionp:
      'LCC is a multinational conglomerate bringing together leading companies across construction, infrastructure, energy, and finishing industries. Delivering innovative, high-quality projects worldwide and setting a consistent standard of excellence across all markets it serves.',
    h1stsectionbutton1: 'Explore Our Services',
    h1stsectionbutton2: 'Explore Our Subsidiaries',
    OurServices: 'Our Services',
    RoadsInfrastructure: 'Roads & Infrastructure',
    RoadsInfrastructurep:
      'High-quality asphalt, concrete, and stabilized road solutions',
    Bridges: 'Bridges',
    Bridgesp: 'Engineered for durability, safety, and long-term performance',
    BuildingConstruction: 'Building Construction',
    BuildingConstructionp:
      'Residential, commercial, and institutional projects',
    SpecializedInfrastructure: 'Specialized Infrastructure',
    SpecializedInfrastructurep:
      'Large-scale EPC and complex environment projects',
    ViewallServices: ' View all Services ',
    BuildingLibya: "Building Libya's Future Through Smart Infrastructure",
    ser1: 'Enhancing national connectivity through strategic road networks',
    ser2: 'Supporting international trade and cross-border logistics',
    ser3: 'Delivering infrastructure in challenging environments',
    ser4: 'Improving urban mobility and daily life',
    OurSubsidiaries: 'Our Subsidiaries',
    btnsub: 'Our Subsidiaries',
    about: 'About LCC',
    aboutp:
      'The Libyan Construction Company General Contracting (LCC) is a private, international conglomerate with a proven track record in the construction industry. LCC houses a wide array of companies that specialise in a variety of fields and practices. From construction, to finishing, petrol to infrastructure, LCC aims to deliver the best quality on each and every project.',
    counties: 'Countries',
    ProjectsDelivered: 'Projects Delivered',
    Subsidiariesc: 'Subsidiaries',
    Years: 'Years Experience',
    Mission: 'Our Mission',
    Missionp:
      "At LCC, our mission is to engineer the foundations of a modern Libya. We don't just build roads; we create essential lifelines that connect cities, empower commerce, and improve the daily lives of our communities. By combining local insight with world-class engineering standards, we deliver infrastructure built to endure.",
    Vision: 'Our Vision',
    visionp:
      'To redefine the backbone of Libya by building infrastructure that not only connects places, but also unlocks opportunity, strengthens communities, and powers a new era of national progress.',
    FaizSalaholdin: 'Faiz Salaholdin',
    Chairman: 'Chairman',
    messagetitle: 'Chairman Message',
    ChairmanMessage:
      'The Chairman of LCC and the founding pillar behind the group’s long-standing business legacy. With decades of senior leadership across multiple sectors, he has played a central role in building, scaling, and overseeing a diversified portfolio of regional ventures. His experience spans strategic leadership, capital deployment, and long-term business development across family-owned and institutional structures. As Chairman, he provides strategic direction, governance oversight, and long-term vision, anchoring LCC with experience, stability, and disciplined growth leadership.',
    OurValues: 'Our Values',
    Integrity: 'Integrity',
    Integrityp:
      'We operate with transparency, accountability, and respect, earning trust at every stage of our work.',
    Excellence: 'Excellence',
    Excellencep:
      'We uphold the highest engineering standards, delivering precision, quality, and consistency in every project.',
    Resilience: 'Resilience',
    Resiliencep:
      'We build infrastructure designed to endure, performing reliably across time, environment, and evolving needs.',
    Impact: 'Impact',
    Impactp:
      'We create infrastructure that improves lives, supports economic growth, and contributes to national development.',
    LocalInsight: 'Local Insight',
    localp:
      'We understand the land, the challenges, and the people, ensuring every solution is grounded in context.',
    Safety: 'Safety & Responsibility',
    safetyp:
      'We prioritize the safety of our teams and communities while committing to sustainable and responsible practices.',
    IndustriesCovered: 'Industries Covered',
    IndustriesCoveredp:
      'Our diverse portfolio demonstrates our capability to excel across multiple sectors and project types.',
    RoadConstruction: 'Road Construction & Rehabilitation',
    BridgeEngineering: 'Bridge Engineering',
    ResidentialDevelopment: 'Residential Development',
    CommercialBuildings: 'Commercial Buildings',
    Infrastructure: 'Infrastructure Projects',
    Construction: 'Construction Chemicals',
    Specialized: 'Specialized EPC Projects',
    Security: 'High Security Facilities',
    OurProjects: 'Our Projects in Libya',
    projectp:
      'From Tripoli to Benghazi, our infrastructure reaches every corner of the nation.',
    sInfrastructure: 'Infrastructure',
    road: 'roads',
    roadp:
      'Full-scope road construction from rural tracks to multi-lane national highways, including surfacing, drainage, and road marking.',
    sinfrap:
      "LCC's infrastructure division encompasses roads, highways, bridges, and large-scale civil works across Libya. With decades of hands-on experience and a strong local workforce, we deliver critical national infrastructure to the highest international standards, on time and within budget.",
    Petrol: 'Petrol Infrastructure',
    pertolp:
      "Construction and rehabilitation of fuel pipeline corridors, pumping stations, and storage facilities across Libya's energy network.",
    FullScope: 'Full-Scope Civil Works',
    fullscopep:
      'End-to-end civil contracting for earthworks, retaining structures, culverts, and ancillary infrastructure works.',
    bridges: 'Bridges',
    bridgesp:
      'Design and construction of bridge structures including assessment, rehabilitation, and full replacement of aging crossings.',
    BuildingLibyat: "Building Libya's",
    Future: 'Future',
    Inspired: 'Through Inspired Infrastructure',
    Inspiredp:
      'LCC is a leading force in Libya’s infrastructure revival, delivering advanced road construction, asphalt surfacing, and sustainable engineering solutions. By prioritizing durability and innovation, LCC strengthens transport networks to drive economic recovery and regional growth.',
    KeyProjects: 'Key Projects',
    TransRegional: 'Trans-Regional Connectivity: Sirte – Jufra',
    FOCUS: 'FOCUS',
    FOCUSP: 'Regional connectivity enhancement.',
    IMPACT: 'IMPACT',
    IMPACTP: '10km road improving logistics and reducing travel time.',
    Derna: 'Derna Lifeline: Al Bayda – Derna',
    International: 'International Trade Arteries: Tobruk – Emsaad',
    Urban: 'Urban Modernisation: Amrour Road Flyover',
    Core: 'Core Competencies',
    Sustainable: 'Sustainable Pavement Recycling',
    SustainableP:
      'We utilize Cold In-Place Recycling (CIR) to minimize environmental impact and reduce material costs without sacrificing road longevity.',
    Precision: 'Precision Engineering',
    PrecisionP:
      ' Utilizing high-grade bitumen and concrete to meet international durability standards (AASHTO/ASTM).',
    Local: 'Local Resilience',
    Localp:
      'Deep logistical knowledge of the Libyan terrain, ensuring project delivery even in challenging geographical conditions.',
    Full: 'Full Depth Reclamation (FDR)',
    fullp:
      'FDR is a rehabilitation technique where asphalt and underlying materials are blended into a stronger, uniform base. This innovative approach transforms deteriorating roads into durable, high-performance infrastructure.',
    Cost: 'Cost Reduction',
    Costp: 'Save up to 50% compared to traditional methods',
    Faster: 'Faster Construction',
    fasterp: 'Accelerated timeline with minimal disruption',
    Environmental: 'Environmental Benefits',
    Environmentalp: 'Sustainable recycling of existing materials',
    Stronger: 'Stronger Performance',
    Strongerp: 'Enhanced structural integrity and durability',
    stext2:
      'Bridges represent a critical element of modern infrastructure and a complex constructional under-taking that requires planning and expertise from various engineering fields. Civil engineers calculate load capacities to ensure the structure can withstand the weight of traffic and external forces like wind and seismic activity. Material science plays a crucial role, with the selection of steel, concrete or even wood influencing the bridge’s strength, weight and aesthetics.',
    BridgeEngineeringp:
      'Design, construction, and rehabilitation of highway bridges, pedestrian bridges, and complex structures.',
    LargeScale: 'Large-Scale Civil Works',
    LargeScalep:
      'Comprehensive infrastructure projects including earthworks, drainage, and site development.',
    Highway: 'Highway Construction',
    Highwayp:
      'Multi-lane highway projects with advanced safety features and modern design standards.',
    sBuildingConstructionp:
      'Building construction forms the essential backbone of our built environment, encompassing residential, commercial, institutional and infrastructure projects and functioning as the foundation for communities, enabling residents, businesses and institutions to function effectively.',
    sBuildingConstructionspan:
      'Ozone Data Center, Benghazi - Client Sewedy Digital Building',
    ILLEGAL: 'ILLEGAL IMMIGRATION AGENCY',
    ILLEGALp:
      'LCC was awarded an EPC contract to build essential infrastructure for managing migration in Eastern and Southern Libya. The project involves the construction of 20 specialized facilities, covering a total area of over 150,000 m2. This undertaking highlights our ability to deliver large-scale, secure infrastructure in challenging environments.',
    oursub:
      'A portfolio of specialized companies delivering excellence across the construction value chain.',
    PILETECH: 'PILETECH',
    ENGINEERINGCOMPANY: 'ENGINEERING COMPANY',
    PILETECHp1:
      'PILETECH is a leading foundation engineering company specializing in deep foundation design and execution. Driven by innovation, safety and quality, the company delivers comprehensive geotechnical solutions that meet the demands of modern construction. A partnership between Libyan and Chinese entrepreneurs, PILETECH is managed by professionals with over 30 years of experience.',
    PILETECHp2:
      'Through its subsidiary, Gulf Piling & Earthworks Company (LCC), it provides specialized services in deep foundations, shoring, and dewatering. With over 10 years of experience and more than 50 completed projects across Libya, China, Egypt, the UAE, and Saudi Arabia, PILETECH has built a strong track record with major clients such as Orascom Construction and CCC.',

    PILETECHp3:
      'Landmark projects include the Tripoli Ring Road and multiple bridge works in Eastern Libya. PILETECH is committed to timely delivery, cost-effective engineering and maintaining the highest safety standards across all operations.',
    PILETECHp4:
      'Tripoli Ring Road - Bridges in Eastern Libya (multiple projects)',
    PILETECHspan: 'Clients & Partnerships:',
    PILETECHp5:
      'Orascom Construction - CCC (China Communications Construction Company)',
    PILETECHspan2: 'Geographic Footprint: ',
    PILETECHp6: ' Libya | Egypt | UAE | Saudi Arabia | China',
    QUICRETE: 'QUICRETE',
    CONCRETECOMPANY: 'CONCRETE COMPANY',
    QUICRETEp1:
      'Founded in 2018 by three young entrepreneurs, Quicrete has quickly become a leading provider of ready-mix concrete in Egypt. Combining deep local market knowledge with a network of high-profile clients and partners, the company delivers reliable, high-quality products and services to a wide range of customers, from large industrial contractors to individual homebuilders.',
    QUICRETEp2:
      'With three major operational ready mix plants in Tubruk, Derna, and Badya. Fulfilling extremely critical and complex projects paving the way for Libya’s infrastructure.Quicrete is committed to exceeding expectations through innovative technologies, professional expertise, and rigorous quality standards. Guided by integrity, professionalism, and social responsibility, the company fosters lasting relationships, contributes to community development, and upholds the highest standards of environmental and operational excellence.',
    QUICRETEp3:
      'Badya – Palm Hills (6th of October) - O West – Orascom Development (West Cairo) - Cairo Metro Line 4 - Kent College – O West - Krea Education Projects - Stanford Egypt International Schools - Kawn Schools - Palm Hills Alexandria - Palm Hills New Cairo (500 Acres) - Awsaty Project - Hadayek October',
    SPACELIBYA: 'SPACE LIBYA',
    CONSTRUCTIONCOMPANY: 'CONSTRUCTION COMPANY',
    SPACELIBYAp1:
      'Space Libya for Construction Chemicals is the first industrial facility of its kind in Libya, specializing in the production of chemical admixtures for ready-mix concrete. Established with a clear national vision, the company aims to localize industrial manufacturing and provide products that meet — and often match — leading European and international quality standards.',
    SPACELIBYAp2:
      'From within Libya’s own industrial landscape, LCC manufactures a comprehensive range of advanced chemical products that enhance the performance, quality, and durability of ready-mix concrete.',
    SPACELIBYAp3:
      'Its innovative solutions have made it a preferred partner for contracting companies and concrete plants seeking superior technical performance and long-term reliability.',

    SPACELIBYAp4:
      'LCC is committed to advancing the Libyan industrial sector by delivering globally competitive products built on cutting-edge technology, strong engineering expertise, and strict quality and safety standards. Its work aligns with the fast-paced growth of the construction industry in both local and regional markets.',
    client: 'Clients',
    SPACELIBYAp5:
      'Triple C - Al-Gherabli Group - Arbella - Al-Rehab Company - Alpha Company',
    ProjectScope: 'Project Scope:',
    SPACELIBYAp6:
      'Large-scale infrastructure projects - Ready-mix concrete plants - Contracting companies across Libya',
    AsphaltPlant: 'Asphalt Plant',
    AsphaltFinisher: 'Asphalt Finisher',
    FDR: 'FDR+ Cement Spreader',
    ConcretePaver: 'Concrete Paver',
    ConcreteBatchPlant: 'Concrete Batch Plant',
    Bulldozer: 'Bulldozer',
    Grader: 'Grader',
    CompactRoller: 'Compact Roller',
    Loaders: 'Loaders',
    PilingMachines: 'Piling Machines',
    Excavator: 'Excavator',
    Cranes: 'Cranes',
    Generators: 'Generators',
    DumpTrucks: 'Dump Trucks',
    TotalStation: 'Total Station',
    ConcreteTruckMixers: 'Concrete Truck Mixers',
    MobileConcretePump52m: 'Mobile Concrete Pump 52m',
    MobileConcretePump48n: 'Mobile Concrete Pump 48n',
    MobileConcretePump42n: 'Mobile Concrete Pump 42n',
    PassengerVehicle: 'Passenger Vehicle',
    SiteCaravan: 'Site Caravan',
    conpagep:
      'Get in touch with our team to discuss your project requirements, partnership opportunities, or any inquiries about our services.',
    ContactInformation: 'Contact Information',
    Email: 'Email',
    LibyaOffices: 'Libya Offices',
    TripoliBenghazi: 'Tripoli & Benghazi',
    GlobalPresence: 'Global Presence',
    uk: 'UK • France • Libya • Egypt • UAE',
    BusinessHours: 'Business Hours',
    SundayThursday: 'Sunday – Thursday',
    FridaySaturday: 'Friday – Saturday',
    time: '8:00 AM – 5:00 PM',
    Closed: 'Closed',
    SendUsaMessage: 'Send Us a Message',
    FullName: 'Full Name',
    Organization: 'Organization',
    EmailAddress: 'Email Address',
    phone: 'Phone Number',
    Subject: 'Subject ',
    Message: 'Message ',
    re: '* Required fields. We respect your privacy and will never share your information.',
  },
  ar: {
    text: 'نبني المستقبل. مجموعة متعددة الجنسيات في البناء والبنية التحتية',
    QuickLinks: 'روابط سريعة',
    Explore: 'استكشف',
    Contactt: 'معلومات الاتصال',
    location: 'طرابلس وبنغازي، ليبيا',
    Subsidiaries: 'الشركات التابعة',
    ABOUT: 'من نحن',
    Services: 'الخدمات',
    Contact: 'تواصل معنا',
    Equipment: 'المعدات',
    subfooter: ['شاركنا لبناء بنية تحتية مرنة', 'للمستقبل'],

    h1stsectionh2: 'نصنع المستقبل',
    h1stsectionp:
      'شركة LCC هي مجموعة متعددة الجنسيات تجمع الشركات الرائدة في مجالات البناء والبنية التحتية والطاقة والصناعات والتشطيبات. تقدم مشاريع مبتكرة وعالية الجودة حول العالم، وتضع معيارًا ثابتًا للتميز في جميع الأسواق التي تعمل فيها.',
    h1stsectionbutton1: 'تعرّف على خدماتنا',
    h1stsectionbutton2: 'استكشف خدماتنا',
    OurServices: 'خدماتنا',
    RoadsInfrastructure: 'الطرق والبنية التحتية',
    RoadsInfrastructurep:
      'حلول طرق عالية الجودة من الأسفلت والخرسانة مع مراعاة الاستدامة  ',
    Bridges: 'تشييد المباني',
    Bridgesp: 'مشاريع سكنية وتجارية ومؤسسية',
    BuildingConstruction: 'الجسور',
    BuildingConstructionp: 'مصممة لضمان المتانة والسلامة والأداء طويل الأمد',
    SpecializedInfrastructure: 'البنية التحتية المتخصصة',
    SpecializedInfrastructurep:
      'مشاريع EPC واسعة النطاق والمشاريع ذات البيئات المعقدة ',
    ViewallServices: ' عرض جميع الخدمات ',
    BuildingLibya: 'نبني مستقبل ليبيا من خلال بنية تحتية ذكية',
    ser1: 'تعزيز الترابط الوطني من خلال شبكات الطرق الاستراتيجية',
    ser2: 'دعم التجارة الدولية والخدمات اللوجستية عبر الحدود',
    ser3: 'توفير البنية التحتية في البيئات الصعبة ',
    ser4: 'تحسين التنقل الحضري والحياة اليومية',
    OurSubsidiaries: 'شركاتنا التابعة',
    btnsub: 'شركاتنا التابعة',
    about: 'عن شركة LCC',
    aboutp:
      'الشركة الليبية للإنشاءات والمقاولات العامة (LCC) هي مجموعة دولية خاصة تتمتع بسجل حافل في قطاع البناء والتشييد. تضم شركة LCC مجموعة واسعة من الشركات المتخصصة في مجالات وممارسات متنوعة من أعمال البناء والتشطيبات مرورًا بقطاع البترول وصولًا إلى البنية التحتية، تهدف شركة LCC إلى تقديم أفضل جودة في كل مشروع.',
    counties: 'دول',
    ProjectsDelivered: 'مشروع تم إنجازه',
    Subsidiariesc: 'شركات تابعة',
    Years: 'سنة من الخبرة',
    Mission: 'الرسالة',
    Missionp:
      'في LCC، تتمثل مهمتنا في هندسة أسس ليبيا الحديثة. نحن لا نبني الطرق فحسب، بل نخلق شرايين حيوية تربط المدن وتمكّن التجارة وتحسّن الحياة اليومية لمواطنينا نلتزم بتقديم بنية تحتية متينة تتحمل اختبار الزمن والتغيرات المناخية، من خلال الجمع بين الفهم المحلي والمعايير الهندسية العالمية.',
    Vision: 'الرؤية',
    visionp:
      'إعادة تعريف العمود الفقري لليبيا من خلال بناء بنية تحتية لا تربط الأماكن فحسب، بل تفتح أيضًا آفاقًا جديدة للفرص، وتقوي المجتمعات، وتدعم عصرًا جديدًا من التقدم الوطني.',
    FaizSalaholdin: 'صلاح الدين فايز',
    Chairman: 'رئيس مجلس الإدارة',
    messagetitle: 'كلمة رئيس مجلس الإدارة',
    ChairmanMessage:
      'الركيزة الأساسية للمؤسسة، بخبرة تمتد لعقود في مجال الأعمال. شغل مناصب قيادية عليا عبر LCC يمثل رئيس مجلس إدارة قطاعات متعددة، ولعب دورًا محوريًا في بناء وتوسيع المشاريع الإقليمية تمتد خبراته إلى القيادة الاستراتيجية، وإدارة رأس المال، وتطوير الأعمال طويلة المدى ضمن هياكل مؤسسية وعائلية وبصفته رئيسًا للمجلس، يقدم التوجيه الاستراتيجي والإشراف على الحوكمة والرؤية طويلة الأمد، مما يعزز مكانة LCC ويقود النمو والاستقرار.',
    OurValues: 'القيم',
    Integrity: 'النزاهة',
    Integrityp: 'نعمل بشفافية ومسؤولية واحترام في كل مرحلة من مراحل عملنا',
    Excellence: 'التميز',
    Excellencep:
      'نلتزم بأعلى المعايير الهندسية، مقدمين الجودة والدقة والاتساق في كل مشروع.',
    Resilience: 'المرونة',
    Resiliencep:
      'ننشئ بنية تحتية مصممة لتدوم وتعمل بكفاءة عبر الزمن والبيئات المتغيرة.',
    Impact: 'الأثر',
    Impactp:
      'نبتكر بنية تحتية تحسن حياة الناس وتدعم النمو الاقتصادي وتساهم في التنمية الوطنية',
    LocalInsight: 'الفهم المحلي',
    localp:
      'نفهم الأرض والتحديات والسكان لضمان تقديم حلول قائمة على السياق المحلي',
    Safety: 'السلامة والمسؤولية',
    safetyp:
      'نولي أولوية لسلامة فرقنا والمجتمعات مع الالتزام بالممارسات المستدامة.',
    IndustriesCovered: 'القطاعات التي نغطيها',
    IndustriesCoveredp:
      'تُظهر محفظة أعمالنا المتنوعة قدرتنا على التميز في قطاعات متعددة وأنواع مختلفة من المشاريع',
    RoadConstruction: 'إنشاء وإعادة تأهيل الطرق',
    BridgeEngineering: 'هندسة الجسور',
    ResidentialDevelopment: 'التطوير السكني',
    CommercialBuildings: 'مشاريع البنية التحتية',
    Infrastructure: 'كيماويات البناء',
    Construction: 'مشاريع EPC المتخصصة',
    Specialized: 'مشروعات الهندسة والتوريد والإنشاءات المتخصصة',
    Security: 'منشآت عالية التأمين',
    OurProjects: 'مشاريعنا في ليبيا',
    projectp:
      'من طرابلس إلى بنغازي، تصل بنيتنا التحتية إلى كل ركن من أركان الوطن.',
    sInfrastructure: 'البنية التحتية',
    road: 'الطرق',
    roadp:
      'ُتعد LCC رائدة في صناعة بناء الطرق، حيث تقدم حلوًلا عالية الجودة للأسفلت والخرسانة وإعادة تدوير الأرصفة لمجموعة واسعة من العملاء، مستندة إلى فهم عميق للدور الحيوي الذي تلعبه البنية التحتية المتينة والمستدامة في تسهيل النقل الفعال وتعزيز النمو الاقتصادي.',

    sinfrap:
      'متعدد الاستخدامات ومستدام، ُيستخدم للطرق ومواقف السيارات والمزيد.(مصنوع من الركام )الحصى والرمل( والبيتومين )المادة ال ُملزمة.',
    Petrol: 'إعادة تدوير الأرصفة',
    pertolp:
      'يعيد استخدام مواد الأرصفة القديمة، مو ّف ًرا الموارد ومقل ًلا من النفايات في المكبات. تشمل التقنيات إعادة التدوير في الموقع بالحرارة أو بالبرودة، وإعادة التدوير في المصنع المركزي، واستصلاح كامل العمق.',
    FullScope: 'الخرسانة',
    fullscopep:
      'متينة وطويلة الأمد (تدوم 2-4 أضعاف عمر الأسفلت). تتحمل الأحمال الثقيلة جيدًا، وتقاوم التشقق والانبعاج.  صديقة للبيئة: قابلة لإعادة التدوير وتقلل من استهلاك الوقود. مصنوعة من الحجر الجيري.',
    bridges: 'استصلاح كامل العمق',
    bridgesp:
      'هي تقنية لإعادة تأهيل الأرصفة، تقوم بإعادة تدوير الأسفلت الحالي والمواد الأساسية تحته لإنشاء قاعدة أقوى وأكثر تماسكًا.',
    BuildingLibyat: 'ناء مستقبل',
    Future: 'ليبيا',
    Inspired: 'من خلال بنية تحتية ذكية                  ',
    Inspiredp:
      'تُعد LCC قوة رائدة في إحياء البنية التحتية في ليبيا، حيث تقدّم حلولًا متقدمة في بناء الطرق، وتغطية الأسفلت، والهندسة المستدامة. من خلال التركيز على المتانة والابتكار، تعزز LCC شبكات النقل لدعم التعافي الاقتصادي والنمو الإقليمي.',
    KeyProjects: 'المشاريع الرئيسية   ',
    TransRegional: 'الربط الإقليمي العابر: سرت – الجفرة',
    FOCUS: 'التركيز:',
    FOCUSP: 'تعزيز الربط الإقليمي',
    IMPACT: 'الأثر:',
    IMPACTP: 'طريق بطول 10 كم يُحسّن الخدمات اللوجستية ويُقلّل زمن التنقل   ',
    International: 'شرايين التجارة الدولية: طبرق – امساعد',
    Derna: 'شرايين التجارة الدولية: طبرق – امساعد',
    Urban: 'شرايين الصحراء: أوباري – غات',
    Core: 'الكفاءات الأساسية',
    Sustainable: 'المرونة المحلية',
    SustainableP:
      'نمتلك معرفة لوجستية عميقة بطبيعة الأراضي الليبية، مما يضمن تنفيذ المشاريع حتى في الظروف الجغرافية الصعبة.',
    Precision: 'المرونة المحلية',
    PrecisionP:
      ' نمتلك معرفة لوجستية عميقة بطبيعة الأراضي الليبية، مما يضمن تنفيذ المشاريع حتى في الظروف الجغرافية الصعبة.',
    Local: 'إعادة تدوير الرصف المستدام',
    Localp:
      'نستخدم تقنية إعادة التدوير على البارد في الموقع (CIR) لتقليل الأثر البيئي وخفض تكاليف المواد دون التأثير على عمر الطريق. ',
    Full: '(ما هو )استصلاح كامل العمق',
    fullp:
      'هي تقنية إعادة تأهيل تقوم بسحق وخلط كامل سمك طبقة الأسفلت وكمية محددة مسبقًا من المواد الأساسية تحتها (القاعدة، الطبقة الفرعية، أو التربة السفلية)، بهدف إنتاج مادة محسّنة وموحدة.',
    Cost: 'أداء أقوى',
    Costp: 'تعزيز السلامة الهيكلية والمتانة',
    Faster: 'فوائد بيئية',
    fasterp: 'إعادة تدوير مستدامة للمواد القائمة',
    Environmental: 'تنفيذ أسرع',
    Environmentalp: 'جدول زمني مُسرّع مع حد أدنى من التعطيل',
    Stronger: 'خفض التكاليف',
    Strongerp: 'توفير يصل إلى 50٪ مقارنة بالطرق التقليدية ',
    stext2:
      'تمثل الجسور عنصرًا حيويًا في البنية التحتية الحديثة، وهي مشروع إنشائي معقد يتطلب التخطيط والخبرة من مختلف المجالات الهندسية. يقوم المهندسون المدنيون بحساب قدرات التحمل لضمان أن الهيكل يمكنه مقاومة أوزان المرور والقوى الخارجية مثل الرياح والنشاط الزلزالي. كما تلعب علوم المواد دورًا أساسيًا، حيث يؤثر اختيار المواد مثل الصلب أو الخرسانة أو حتى الخشب على قوة الجسر ووزنه وجماليته.',
    BridgeEngineeringp:
      'مشاريع طرق متعددة المسارات مع ميزات أمان متقدمة ومعايير تصميم حديثة',
    LargeScale: 'الأعمال المدنية واسعة النطاق',
    LargeScalep:
      'مشاريع بنية تحتية شاملة تشمل أعمال الحفر، وتصريف المياه، وتطوير المواقع',
    Highway: 'هندسة الجسور',
    Highwayp:
      'تصميم وبناء وإعادة تأهيل جسور الطرق السريعة، وجسور المشاة، والهياكل المعقدة ',
    sBuildingConstructionp:
      'يشكل بناء المباني العمود الفقري الأساسي لبيئتنا المبنية، ويشمل المشاريع السكنية والتجارية والمؤسسية والبنية التحتية، ويعمل كأساس للمجتمعات، مما يمكّن السكان والشركات والمؤسسات من العمل بكفاءة.',
    sBuildingConstructionspan:
      'مركز بيانات أوزون، بنغازي – العميل: مبنى Sewedy Digital',
    ILLEGAL: 'وكالة الهجرة غير القانونية',
    ILLEGALp:
      'تم تكليف LCC بعقد EPC لبناء البنية التحتية الأساسية لإدارة الهجرة في شرق وجنوب ليبيا. يشمل المشروع إنشاء 20 منشأة متخصصة، بمساحة إجمالية تزيد عن 150,000 متر مربع. يبرز هذا المشروع قدرتنا على تنفيذ بنية تحتية واسعة النطاق وآمنة في بيئات صعبة.',
    oursub:
      'مجموعة من الشركات المتخصصة التي تقدم التميز في جميع مراحل سلسلة القيمة في قطاع البناء.',
    PILETECH: 'PILETECH',
    ENGINEERINGCOMPANY: 'شركة هندسية',
    PILETECHp1:
      'تُعد PILETECH شركة رائدة في هندسة الأساسات، متخصصة في تصميم وتنفيذ الأساسات العميقة. مدفوعة بالابتكار والسلامة والجودة، تقدم الشركة حلولًا جيوتقنية شاملة تلبي متطلبات البناء الحديث. تُدار الشركة كشراكة بين رواد أعمال ليبيين وصينيين، ويديرها محترفون يمتلكون أكثر من 30 عامًا من الخبرة',
    PILETECHp2:
      'من خلال شركتها التابعة، شركة الخليج للأساسات والحفر (LCC)، تقدم PILETECH خدمات متخصصة في الأساسات العميقة، والدعامات، وتجفيف المواقع. مع خبرة تتجاوز 10 سنوات وأكثر من 50 مشروعًا مكتملًا في ليبيا، والصين، ومصر، والإمارات، والسعودية، بنت PILETECH سجلًا قويًا مع عملاء كبار مثل Orascom Construction وCCC.',

    PILETECHp3:
      'تشمل المشاريع البارزة طريق حلقة طرابلس والعديد من أعمال الجسور في شرق ليبيا. تلتزم PILETECH بالتسليم في الوقت المحدد، والهندسة الاقتصادية، والحفاظ على أعلى معايير السلامة في جميع العمليات.',
    PILETECHp4: 'طريق حلقة طرابلس – جسور في شرق ليبيا (عدة مشاريع)',
    PILETECHspan: 'لعملاء والشراكات',
    PILETECHp5: 'Orascom Construction – CCC (شركة الصين للاتصالات والبناء)',
    PILETECHspan2: 'Geographic Footprint: ',
    PILETECHp6: 'الانتشار الجغرافي: ليبيا | مصر | الإمارات | السعودية | الصين',
    QUICRETE: 'QUICRETE',
    CONCRETECOMPANY: 'شركة الخرسانة',
    QUICRETEp1:
      'تأسست Quicrete في عام 2018 على يد ثلاثة من رواد الأعمال الشباب، وسرعان ما أصبحت مزودًا رائدًا للخرسانة الجاهزة في مصر. من خلال الجمع بين معرفة السوق المحلية العميقة وشبكة من العملاء والشركاء البارزين، تقدّم الشركة منتجات وخدمات عالية الجودة وموثوقة لمجموعة واسعة من العملاء، من المقاولين الصناعيين الكبار إلى أصحاب المشاريع السكنية الفردية.',
    QUICRETEp2:
      'تمتلك الشركة ثلاث مصانع رئيسية للخرسانة الجاهزة في طبرق، درنة، وباديا، مما يتيح تنفيذ مشاريع حرجة ومعقدة تمهّد الطريق للبنية التحتية في ليبيا. تلتزم Quicrete بتجاوز التوقعات من خلال التقنيات المبتكرة، والخبرة المهنية، ومعايير الجودة الصارمة. بقيادة قيم النزاهة والاحترافية والمسؤولية الاجتماعية، تعمل الشركة على بناء علاقات دائمة، والمساهمة في تنمية المجتمع، والحفاظ على أعلى معايير التميز البيئي والتشغيلي.',
    QUICRETEp3:
      ' باديا – بالم هيلز (6 أكتوبر) – O West – تطوير أوراسكوم (غرب القاهرة) – الخط الرابع لمترو القاهرة – كينت كوليدج O West – مشاريع التعليم Krea – مدارس ستانفورد مصر الدولية – مدارس كاون – بالم هيلز الإسكندرية – بالم هيلز القاهرة الجديدة (500 فدان) – مشروع أوساتي – حدائق أكتوبر ',
    SPACELIBYA: 'SPACE LIBYA',
    CONSTRUCTIONCOMPANY: 'شركة إنشاءات',
    SPACELIBYAp1:
      'عد Space Libya للمواد الكيميائية في البناء أول منشأة صناعية من نوعها في ليبيا، متخصصة في إنتاج الإضافات الكيميائية للخرسانة الجاهزة. تأسست الشركة برؤية وطنية واضحة، وتهدف إلى توطين الصناعة المحلية وتقديم منتجات تلبي — وغالبًا تطابق — معايير الجودة الأوروبية والدولية الرائدة.',
    SPACELIBYAp2:
      'من قلب الصناعة الليبية، تقوم LCC بإنتاج مجموعة شاملة من المنتجات الكيميائية المتقدمة التي تعزز أداء وجودة ومتانة الخرسانة الجاهزة.',
    SPACELIBYAp3:
      'لقد جعلت حلولها المبتكرة منها شريكًا مفضّلًا لشركات المقاولات ومحطات الخرسانة التي تسعى للحصول على أداء تقني متفوق وموثوقية طويلة الأمد.',

    SPACELIBYAp4: '',
    client: 'العملاء',
    SPACELIBYAp5:
      'Triple C – مجموعة الغرابلي – أربيلّا – شركة الرحاب – شركة ألفا',
    ProjectScope: 'نطاق المشروع:',
    SPACELIBYAp6:
      'مشاريع بنية تحتية واسعة النطاق – محطات خرسانة جاهزة – شركات مقاولات في جميع أنحاء ليب ',
    AsphaltPlant: 'محطة خلط الخرسانة',
    AsphaltFinisher: 'محطة الأسفلت',
    FDR: 'آلة تسوية الأسفلت',
    ConcretePaver: 'آلة تسوية الأسفلت',
    ConcreteBatchPlant: 'معدات استصلاح كامل العمق + مفرّش الأسمنت',
    Bulldozer: 'آلة فرش الخرسانة',
    Grader: 'جرافة',
    CompactRoller: 'مدحلة مدمجة',
    Loaders: 'لودرات / آلات تحميل',
    PilingMachines: 'آلات دفع الأساسات',
    Excavator: 'حفارة',
    Cranes: 'رافعات',
    Generators: 'مولدات كهربائية',
    DumpTrucks: 'محطة المسح الشاملة',
    TotalStation: 'Total Station',
    ConcreteTruckMixers: 'شاحنات خلط الخرسانة',
    MobileConcretePump52m: 'مضخة خرسانة متنقلة 52N',
    MobileConcretePump48n: 'مضخة خرسانة متنقلة 48N',
    MobileConcretePump42n: 'مضخة خرسانة متنقلة 42N',
    PassengerVehicle: 'مركبة ركاب ',
    SiteCaravan: 'كرافان الموقع / قافلة الموقع',
    conpagep:
      'تواصل مع فريقنا لمناقشة متطلبات مشروعك، فرص الشراكة، أو أي استفسارات حول خدماتنا.',
    Email: 'البريد الإلكتروني',
    LibyaOffices: 'مكاتب ليبيا',
    TripoliBenghazi: 'طرابلس وبنغازي',
    GlobalPresence: 'التواجد العالمي',
    uk: 'المملكة المتحدة • فرنسا • ليبيا • مصر • الإمارات العربية المتحدة',
    BusinessHours: 'Business Hours',
    SundayThursday: 'الأحد - الخميس:',
    FridaySaturday: 'الجمعة - السبت',
    time: '8:00 صباحًا – 5:00 مساءً',
    Closed: 'مغلق  ',
    SendUsaMessage: 'أرسل لنا رسالة',
    FullName: 'الاسم الكامل*',
    Organization: 'المؤسسة',
    EmailAddress: 'البريد الإلكتروني*',
    phone: 'رقم الهاتف',
    Subject: 'الموضوع* ',
    Message: 'الرسالة* ',
    re: '* الحقول المطلوبة : نحترم خصوصيتك ولن نشارك معلوماتك أبدًا',
  },
};
